<template>
  <div class="email-block">
    <div class="row-new">
      <div class="col-10 col-md-6 mx-auto mx-md-0">
        <label class="label" for="email">{{
          insertString("LoyaltyRegistration", "YourEmail")
        }}</label>
        <input
          id="email"
          spellcheck="false"
          type="email"
          v-model="emailInput"
          :placeholder="insertString('Global', 'EmailPlaceholder')"
          :class="{ errorInput: error }"
          @focus.stop="
            () => {
              error = false;
            }
          "
          @keydown.enter="submit()"
        />
        <div class="alert-error" v-show="error">
          {{ insertString("Global", "EmailErrorFormat") }}
        </div>
      </div>
      <div class="col-10 col-md-4 mx-auto mx-md-0">
        <ButtonComponent
          :text="insertString('Global', 'Account', 'JoinNow')"
          theme="cta"
          :overrideThemeColor="Globals.colors.green"
          :block="true"
          @click="submit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ButtonComponent from '@/Scripts/components/shared/ButtonV2/ButtonV2.vue';
export default {
  components: {
    ButtonComponent
  },
  data () {
    return {
      error: false
    };
  },
  props: {
    email: String
  },
  computed: {
    emailInput: {
      get: function () {
        return this.email;
      },
      set: function (value) {
        this.$emit('on-input', value);
      }
    }
  },
  methods: {
    submit () {
      const pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;

      if (this.email && pattern.test(this.email)) {
        this.error = false;
        this.$emit('startRegistration');
      } else {
        this.error = true;
      }
    }
  }
};
</script>

<style lang="scss" src="@/scss/components/components.email.block.scss"></style>
